import { Spinner as UIKitSpinner } from '@cian/ui-kit';

import * as style from './Spinner.css';

export const Spinner = () => {
  return (
    <div className={style['spinner']}>
      <UIKitSpinner size={32} />
    </div>
  );
};
